module.exports = __webpack_public_path__ + "static/AWS-ARTICLE-IMAGES-5-800x450-76b4ee6b091c24073d38fb65b371ac30.png";